import {Box} from '@chakra-ui/react';
import {theme} from '../../style/theme';

export interface PieChartProps {
  percentage: string;
  color: string;
}

export const PieChart: React.FC<PieChartProps> = ({percentage, color}) => {
  return (
    <Box
      position="relative"
      width="50px"
      height="50px"
      overflow="hidden"
      borderRadius="50%"
    >
      <Box
        width="48px"
        height="48px"
        borderRadius="50%"
        background="black"
        backgroundImage={`conic-gradient(${theme.colors[color]} ${percentage}, #000000 0)`}
        transform="translate3d(-50%, -50%, 0)"
        position="absolute"
        left="50%"
        top="50%"
        zIndex="1"
      />
      <Box
        width="24px"
        height="24px"
        borderRadius="50%"
        background="white"
        transform="translate3d(-50%, -50%, 0)"
        position="absolute"
        left="50%"
        top="50%"
        zIndex="2"
      />
    </Box>
  );
};
